import { render, staticRenderFns } from "./UpdatesViewer.vue?vue&type=template&id=34d48332&scoped=true&"
import script from "./UpdatesViewer.vue?vue&type=script&lang=ts&"
export * from "./UpdatesViewer.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatesViewer.vue?vue&type=style&index=0&id=34d48332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d48332",
  null
  
)

export default component.exports